export default __webpack_public_path__ + "static/media/ANEXO-I-BENEFICIARIO-BENEFICIARIO-PARTE-PJ-OPTANTE-PELO-SIMPLES.e726c19b.docx";